import { render, staticRenderFns } from "./LoginInvest.vue?vue&type=template&id=631dc4f3&scoped=true&"
import script from "./LoginInvest.vue?vue&type=script&lang=js&"
export * from "./LoginInvest.vue?vue&type=script&lang=js&"
import style0 from "./LoginInvest.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LoginInvest.vue?vue&type=style&index=1&id=631dc4f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631dc4f3",
  null
  
)

export default component.exports